export enum MerchantRequestOperation {
  GetList = 'get_list',
  Get = 'get',
  GetByExternalOrderId = 'get_by_external_order_id',
  Create = 'create',
  CreateSyncRequisites = 'create_sync_requisites',
  Update = 'update',
  Cancel = 'cancel',
  StartPayment = 'start_payment',
  ConfirmPayment = 'confirm_payment',
  GetPaymentFields = 'get_payment_fields',
  GetReceipts = 'get_receipts',
  RemoveReceipt = 'remove_receipt',
  GenerateReceiptUrl = 'generate_receipt_url',
  UploadReceipt = 'upload_receipt',
  Dispute = 'dispute',
  DisputeByExternalOrderId = 'dispute_by_external_order_id',
  CancelDispute = 'cancel_dispute',
  CancelDisputeByExternalOrderId = 'cancel_dispute_by_external_order_id',
}
